/* eslint-disable max-len */
import { ERoutePathParams } from '../enums/rout-path-params.enum';

export const ROUTES_MAPPING = {
  ROOT: '/',
  NO_MATCH: '/404',
  RESET_PASSWORD: '/reset-password',
  PROTECTED: {
    DASHBOARD: '/dashboard',
    PAYMENT: '/payments',
    PAYMENT_STATUS: '/payments/status',
    PAYMENT_OPERATION: `/payments/operation/`,
    REPORTING: '/reporting',
    REPORTING_EMISSION_HISTORY: '/reporting/emission-history',
    REPORTING_PAYMENT_OPERATIONS: '/reporting/payments',
    REPORTING_AUDIT: '/reporting/audit',
    USER_ROLE_MANAGEMENT: '/user-role-management',
    USER_ROLE_MANAGEMENT_BRANCHES: '/user-role-management/branches',
    USER_ROLE_MANAGEMENT_COUNTERPARTIES: '/user-role-management/counterparties',
    USER_ROLE_MANAGEMENT_ROLES: '/user-role-management/roles',
    USER_ROLE_MANAGEMENT_CREATE_ROLE: '/user-role-management/roles/create',
    USER_ROLE_MANAGEMENT_BRANCH_ROLES: '/user-role-management/branch-roles',
    USER_ROLE_MANAGEMENT_CUSTOMERS: '/user-role-management/customers',
    USER_ROLE_MANAGEMENT_MERCHANTS: '/user-role-management/merchants',
    USER_ROLE_MANAGEMENT_PERMISSIONS: '/user-role-management/permissions',
    USER_ROLE_MANAGEMENT_EMPLOYEES: '/user-role-management/employees',
    USER_ROLE_MANAGEMENT_KYC: '/user-role-management/kyc',

    ACCOUNT_MANAGEMENT_CUSTOMERS: '/account-management/customers',

    ACCOUNT_MANAGEMENT: '/account-management',
    ACCOUNT_MANAGEMENT_COUNTERPARTY_EMISSION: `/account-management/emission`,
    ACCOUNT_MANAGEMENT_CREATE_COUNTERPARTY_EMISSION: `/account-management/emission/create`,
    ACCOUNT_MANAGEMENT_EDIT_COUNTERPARTY_EMISSION: `/account-management/emission/${ERoutePathParams.Account}/edit`,
    ACCOUNT_MANAGEMENT_COUNTERPARTY_PROCESSING: `/account-management/processing`,
    ACCOUNT_MANAGEMENT_CREATE_COUNTERPARTY_PROCESSING: `/account-management/processing/create`,
    ACCOUNT_MANAGEMENT_EDIT_COUNTERPARTY_PROCESSING: `/account-management/processing/${ERoutePathParams.Account}/edit`,

    LIMITS: '/limits',
    LIMITS_STANDARD_LIMITS: '/limits/standard-limits',
    LIMITS_INDIVIDUAL_LIMITS: '/limits/individual-limits',

    APPEAL_AND_ARBITRATION: '/appeal-and-arbitration',

    ASSETS: '/assets',

    COMMISSION_AND_CONVERSION: '/commission-and-conversion',

    RECONCILIATION: '/reconciliation',
    RECONCILIATION_STATISTIC: `/reconciliation/statistic/${ERoutePathParams.Status}?`,
    RECONCILIATION_TABLE: '/reconciliation/table',
    RECONCILIATION_NOTIFICATIONS: '/reconciliation/notifications',
  },
  PUBLIC: {
    LOGIN: '/login',
    CONFIRM_CODE: '/confirm-code',
    CREATE_NEW_PASSWORD: '/create-new-password',
  },
};
